export enum LicenseStatusEnum {
    Perpetual = 0,
    Demo = 1,
    NotEnabled = 2,
    Expired = 3,
    VersionNotEnabled = 4,
}
